// Module
var code = "<img ng-src=\"/dist/img/help/crosssession.png\" alt=\"This action is not allowed\"/><div class=\"gh-empty-module\"><div class=\"gh-empty-module-title\">{{ \"this_action_not_allowed\" | localize }}</div><p>{{ \"align_objective_rule_descr\" | localize }}</p></div>";
// Exports
module.exports = code;